module.exports = __webpack_public_path__ + "img/27ne.14fa4e23.svg";